export default "__VITE_ASSET__ac487bd6__"